<template>
    <b-container>
        <h3>Schnellzugriffe:</h3>
        <hr class="mt-4 mb-4">
        <b-list-group>
            <draggable v-model="quickAccesses" handle=".handle" @change="savePositions()">
                <b-list-group-item
                    v-for="quickAccess in quickAccesses" :key="quickAccess.position"
                >
                    <b-row>
                        <b-col><router-link :to="{ path: `/Schnellzugriff/${quickAccess.id}` }">{{ quickAccess.name }}</router-link></b-col>
                        <b-col cols="1">
                            <b-icon-list class="handle"></b-icon-list>
                        </b-col>
                    </b-row>
                </b-list-group-item>
            </draggable>
        </b-list-group>
    </b-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import draggable from 'vuedraggable';
export default {
    name: 'QuickAccessList',
    components: {
        draggable
    },
    methods: {
        ...mapActions([
            'getQuickAccesses',
            'saveQuickAccessPositions',
        ]),
        ...mapMutations([
            'setQuickAccesses'
        ]),
        savePositions() {
            const quickAccesses = this.quickAccesses.map((el, index) => el = {id: el.id, position: index})
            this.saveQuickAccessPositions({quickAccesses})
        }
    },
    computed: {
        ...mapGetters([
            'getStoredQuickAccesses'
        ]),
        quickAccesses: {
            get() {
                return this.getStoredQuickAccesses
            },
            set(value) {
                this.setQuickAccesses(value)
            }
        },
    },
    mounted() {
        this.getQuickAccesses()
    }
}
</script>

<style scoped>

</style>
